import { formatDateKeyWithTimezone, formatTimeWithTimezone } from './dateUtils';

interface ScheduleWaitlistContinuationContext {
  restaurant_slug: string;
  date: string;
  time: string;
  party_size: number;
}

interface ScheduleReadyReservationContext {
  id: string | number;
  start_at?: string | null;
  party_size: string | number;
  restaurant?: {
    id?: string | number | null;
    name?: string | null;
  } | null;
}

type ScheduleReadyRedirectResult =
  | {
      ok: true;
      path: string;
    }
  | {
      ok: false;
      error: 'invalid_start_at' | 'missing_restaurant_identifier';
    };

export function resolveReservationId(routeReservationId?: string, queryReservationId?: string | null): string | null {
  return routeReservationId || queryReservationId || null;
}

export function buildLatestReservationPath(restaurantId: string | number, waitlistEntryId?: string | number | null): string {
  const params = new URLSearchParams({ restaurant_id: String(restaurantId) });
  if (waitlistEntryId !== undefined && waitlistEntryId !== null && waitlistEntryId !== '') {
    params.set('waitlist_entry_id', String(waitlistEntryId));
  }

  return `/reservations/latest?${params.toString()}`;
}

export function buildScheduleWaitlistContinuationUrl(continuation: ScheduleWaitlistContinuationContext): string {
  const params = new URLSearchParams({
    date: continuation.date,
    time: continuation.time,
    pax: String(continuation.party_size),
    'restaurant-slug': continuation.restaurant_slug
  });

  return `/customer/add-reservation?${params.toString()}`;
}

export function buildScheduleReadyWaiterSelectionUrl(
  reservation: ScheduleReadyReservationContext,
  timezone: string
): ScheduleReadyRedirectResult {
  const startAt = reservation.start_at?.trim();
  if (!startAt || Number.isNaN(new Date(startAt).getTime())) {
    return { ok: false, error: 'invalid_start_at' };
  }

  const restaurantIdentifier = reservation.restaurant?.id ?? reservation.restaurant?.name;
  if (restaurantIdentifier === null || restaurantIdentifier === undefined || restaurantIdentifier === '') {
    return { ok: false, error: 'missing_restaurant_identifier' };
  }

  const params = new URLSearchParams({
    date: formatDateKeyWithTimezone(startAt, timezone),
    time: formatTimeWithTimezone(startAt, timezone),
    pax: String(reservation.party_size),
    'restaurant-slug': String(restaurantIdentifier),
    reservation_id: String(reservation.id)
  });

  return {
    ok: true,
    path: `/customer/add-reservation?${params.toString()}`
  };
}
